var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 8.33366H2.50012M13.3335 1.66699V5.00033M6.66679 1.66699V5.00033M6.50012 18.3337H13.5001C14.9003 18.3337 15.6003 18.3337 16.1351 18.0612C16.6055 17.8215 16.988 17.439 17.2276 16.9686C17.5001 16.4339 17.5001 15.7338 17.5001 14.3337V7.33366C17.5001 5.93353 17.5001 5.23346 17.2276 4.69868C16.988 4.22828 16.6055 3.84583 16.1351 3.60614C15.6003 3.33366 14.9003 3.33366 13.5001 3.33366H6.50012C5.09999 3.33366 4.39993 3.33366 3.86515 3.60614C3.39474 3.84583 3.01229 4.22828 2.77261 4.69868C2.50012 5.23346 2.50012 5.93353 2.50012 7.33366V14.3337C2.50012 15.7338 2.50012 16.4339 2.77261 16.9686C3.01229 17.439 3.39474 17.8215 3.86515 18.0612C4.39993 18.3337 5.09999 18.3337 6.50012 18.3337Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.78316cabd2a3550f64590ea615759414.svg";
export { ForwardRef as ReactComponent };